exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ies-actions td:first-child{\n    padding:0px;\n}\ninput:disabled {\n    background: #dddddd;\n}\n#editForm .col {\n    padding-top: 4px;\n    padding-bottom: 4px;\n}\n", ""]);

// exports
